import type { NormalizedInterval } from 'date-fns'
import { endOfMonth, startOfDay, startOfMonth, startOfWeek, endOfWeek, subDays, subYears, endOfDay } from 'date-fns'

export type IntervalWithDescription = NormalizedInterval & {
  intlKey: string
}

export default function (
  schoolYearPeriod?: NormalizedInterval,
  now = new Date(),
): Record<string, IntervalWithDescription> {
  const { start, end } = schoolYearPeriod ?? {
    start: subYears(now, 1),
    end: now,
  }
  const namedDateRangeObject = {
    'this-week': {
      start: startOfWeek(now),
      // adding 6 days is 7 days duration
      end: endOfWeek(now),
      intlKey: 'presetDateRangeLabels.thisWeek',
    },
    'last-7-days': {
      // subtracting 6 days is 7 days duration
      start: startOfDay(subDays(now, 6)),
      end: endOfDay(now),
      intlKey: 'presetDateRangeLabels.last7Days',
    },
    'this-month': {
      start: startOfMonth(now),
      end: endOfMonth(now),
      intlKey: 'presetDateRangeLabels.thisMonth',
    },
    'last-90-days': {
      start: startOfDay(subDays(now, 89)),
      end: endOfDay(now),
      intlKey: 'presetDateRangeLabels.last90Days',
    },
    'this-year': {
      start: startOfDay(start),
      end: endOfDay(end),
      intlKey: 'presetDateRangeLabels.thisYear',
    },
    'last-year': {
      start: startOfDay(subYears(start, 1)),
      end: endOfDay(subYears(end, 1)),
      intlKey: 'presetDateRangeLabels.lastYear',
    },
  }
  return namedDateRangeObject
}
